import React from "react";
import styles from "../../pages/renewal/Renew.module.css";

/**
 * Warning modal shown when policy is still active (>= 10 months remaining).
 * Offers a download link for the existing certificate.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is visible
 * @param {Function} props.onClose - Handler to close the modal
 * @param {string} props.certUrl - URL to download existing certificate
 */
const WarningModal = ({ isOpen, onClose, certUrl }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modal_overlay} onClick={onClose}>
      <div className={styles.modal_card} onClick={(e) => e.stopPropagation()}>
        <h1 className={styles.modal_title}>Policy Still Active</h1>
        <p style={{ textAlign: "center", color: "gray" }}>
          click the Button below to Download
        </p>

        <a
          href={certUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.modal_button}
          style={{
            textDecoration: "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={onClose}
        >
          Download Certificate
        </a>
      </div>
    </div>
  );
};

export default WarningModal;
